import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Home.css";
import {
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
  Hammer,
  Calendar,
  Contact,
} from "lucide-react";
import About from "./About";
import Services from "./Services";
import OurPortfolio from "./OurPortfolio";
import OurCompany from "./OurCompany";
import OurPartners from "./OurPartners";
import Feedback from "./Feedback";
import ContactUs from "./ContactUs";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <section className="hero-bg d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              {/* Company Name */}
              {/* <p className="text-white-50 mb-3 fs-5">
                Broadway Building Solutions
              </p> */}

              {/* Main Headline */}
              {/* <h1 className="display-3 fw-bold text-white mb-4 lh-1">
                BUILT FOR PROGRESS
                <br />
                SECURED BY BROADWAY
              </h1> */}

              {/* Subtitle */}
              {/* <p className="text-white-50 fs-5 mb-5 col-lg-8">
                Canada's Trusted Partner for Premium Temporary Fencing
                Solutions.
              </p> */}

              {/* Action Buttons */}
              {/* <div className="d-flex gap-3 flex-wrap">
                <button className="btn brand-orange text-white px-4 py-3 fw-semibold d-flex align-items-center gap-2">
                  <Hammer size={20} />
                  PROJECTS
                </button>
                <button className="btn brand-orange-outline px-4 py-3 fw-semibold d-flex align-items-center gap-2">
                  <Calendar size={20} />
                  BOOK A CALL
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <About></About>
      <Services></Services>
      <OurPortfolio></OurPortfolio>
      {/* <OurCompany></OurCompany> */}
      {/* <OurPartners></OurPartners> */}
      <Feedback></Feedback>
      <ContactUs></ContactUs>
    </>
  );
};

export default Home;
